import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { SAVED_DASHBOARDS_QUERY_KEY } from "./useSavedDashboards";

type CreateSavedDashboardBody = components["schemas"]["CreateSavedDashboardBody"];
type SavedDashboardResponse = components["schemas"]["SavedDashboardResponse"];

export function useCreateSavedDashboard() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<SavedDashboardResponse, Error, CreateSavedDashboardBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/saved-dashboards", { body });
      if (error !== undefined) {
        throw new Error("Failed to save dashboard");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: SAVED_DASHBOARDS_QUERY_KEY });
    },
  });
}
